import type { FormFields } from './form.types';

export const REQUIRED_FIELDS = ['streetLine1', 'city', 'stateProvince', 'zipPostalCode'] as const;

export const EMPTY_FORM_VALUES: FormFields = {
    streetLine1: '',
    streetLine2: '',
    city: '',
    stateProvince: '',
    zipPostalCode: '',
};

export const FORM_FIELD_OPTIONS = {
    shouldDirty: true,
    shouldValidate: true,
} as const;
